<template>
  <div>
    <el-form ref="formRef" :model="imgForm" label-width="100px">
      <el-form-item label="排序：">
        <el-input v-model="imgForm.orderNum" placeholder="排序，越大越靠前" style="width:24em;"/>
      </el-form-item>
      <el-form-item label="礼物图片：">
        <img :src="src" alt="" v-if="src" @click="headImgUpdate" class="cursor" style="width: 80px;height: 80px;margin: 0">
        <div class="add" @click="headImgUpdate" v-else>
          <span>+</span>
        </div>
        <input type="file" accept=".jp2,.jpe,.jpeg,.jpg,.png"  @change="headImgChanged" ref="headImg" multiple="multiple" style="display:none;">
      </el-form-item>
    </el-form>
    <div class="dialog-footer">
      <el-button @click.native="cancel" >取消</el-button>
      <el-button type="primary" @click="summit" v-loading="loading">确定</el-button>
    </div>
  </div>

</template>

<script>
import { imgPostFormData } from "@/api/api"
import { addOrUpdateBackGround } from "@/api/url";

export default {
  name: "GiftManageDialog",
  props: {
    value: Object
  },
  data() {
    return {
      imgForm: this.value.imgForm,
      idx: this.value.ids,
      loading: false,

      files: null,
      src: this.value.ids > -1?this.value.imgForm.img:'',

    }
  },
  methods: {
    cancel() {
      this.$emit("close");
    },

    //更改或添加
    headImgUpdate() {
      this.$refs.headImg.click();
    },

    //选取图片
    headImgChanged(e) {
      if(e.target.files[0]) {
        this.files = e.target.files[0];
        var windowURL = window.URL || window.webkitURL;
        this.src = windowURL.createObjectURL(this.files);
      }
    },

    summit() {
      if(!this.imgForm.orderNum) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '排序不能为空',
          type: 'warning'
        });
        return false
      }
      if(!this.src) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '礼物图片不能为空',
          type: 'warning'
        });
        return false
      }
      this.loading = true
      let param = new FormData();
      if (this.idx > -1) {
        param.append('id', this.imgForm.id);
      } else {
        param.append('id', '0');
      }
      param.append('orderNum', this.imgForm.orderNum);
      param.append('file', this.files);
      imgPostFormData(addOrUpdateBackGround, param).then((data) => {
        let {msg, code} = data
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'success'
          });
          this.$emit('confirm')
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
        this.loading = false
      }).catch(()=>{
        this.loading = false
      })
    }
  },
  mounted() {
  }
}
</script>

<style scoped>
.add {
  width: 80px;
  height: 80px;
  text-align: center;
  line-height: 80px;
  border: 1px dashed #ececec;
  font-size: 30px;
  cursor: pointer;
  float: left;
}
</style>
